<div class="if-menu-item-cabinet"
     routerLinkActive="active"
     [class.collapsed]="isCollapsed()"
     [appTooltip]="isCollapsed() && tooltipText() ? tooltipText() : ''"
     [tooltipPosition]="'right'"
     [tooltipDisabled]="!isCollapsed() || !tooltipText()">
    <ng-content></ng-content>
    @if (badge() !== undefined && badge()! > 0) {
        <span class="badge">{{ badge() }}</span>
    }
</div>